
import { ThesisRow as Row} from "@/components/shared";
import { Component, Watch, Mixins } from "vue-property-decorator";
import { HomeRow, Pagination, HomeSearchParams } from "@/view-models";
import { GridViewToggle } from "@/components";
import Persistence from "@/mixins/persistence";
import { _homeService } from "@/services";

import { namespace } from "vuex-class";
const user = namespace("user");

@Component({
  components: {
    GridViewToggle,
    Row
  }
})
export default class AllResults extends Mixins(Persistence) {
  pagination: Pagination = {
    currentPage: 1,
    pageCount: 1,
    totalItemCount: 0,
    pageSize: 10
  };
  private isListView = true;

  @user.State("id")
  public userId!: string;

  results: Array<HomeRow> = [];
  tempParams: HomeSearchParams = {} as HomeSearchParams;

  get getColsSize(): number {
    return this.isListView ? 12 : 6;
  }

  mounted() {
    this.$root.$on("onHomeSearch", (params: HomeSearchParams) => {
      this.tempParams = params;
      this.search(params);
    });
  }

  @Watch("pagination.currentPage")
  currentPageChanged(page: number) {
    this.search(this.tempParams, page);
  }

  search(params: HomeSearchParams, page = 1) {
    _homeService
      .search({
        ...params,
        userId: this.userId,
        isAdmin: false,
        page
      })
      .then(({ data }) => {
        this.results = data.data;

        this.pagination = {
          ...this.pagination,
          pageCount: data.pageCount,
          totalItemCount: data.totalItemCount
        };
      });
  }
}
